import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'upsellModalShown',
  'upsellModalCtaClick',
  'upsellModalSecondaryClick',
  'upsellModalDismissed',
  'upsellBannerShown',
  'upsellBannerCtaClick',
  'upsellBannerDismissed',
] as const;

export const upsellEvents = getMappedEvents([...EVENTS], { shouldSendSubscriptionData: true });
